/**
 * Libellés français des types de réponse d'une question personnalisée.
 *
 * L'API dérive son libellé de la clé technique : `SHORT_TEXT` devient « Short
 * Text », `YES_NO_NSP` devient « Yes No Nsp ». L'écran d'administration
 * affichait donc ses dix-sept types en anglais, au milieu d'une interface
 * entièrement française. La traduction est une affaire d'affichage : elle vit
 * ici, et l'API garde ses clés.
 */
export const QUESTION_TYPE_LABELS = {
  SHORT_TEXT: 'Texte court',
  LONG_TEXT: 'Texte long',
  NUMBER: 'Nombre',
  EMAIL: 'Email',
  PHONE: 'Téléphone',
  URL: 'Adresse web',
  YES_NO: 'Oui / Non',
  YES_NO_NSP: 'Oui / Non / NSP',
  RADIO: 'Choix unique (boutons)',
  SELECT: 'Liste déroulante',
  CHECKBOX: 'Choix multiple (cases)',
  MULTI_SELECT: 'Liste à choix multiple',
  DATE: 'Date',
  TIME: 'Heure',
  DATETIME: 'Date et heure',
  DESCRIPTION: 'Texte d’information',
  HIDDEN: 'Champ masqué',
};

/**
 * Le libellé à afficher pour un type de réponse. Le dictionnaire français
 * d'abord, puis le libellé renvoyé par l'API pour un type qu'il ne
 * connaîtrait pas encore, et la clé en dernier recours.
 *
 * @param {string} key clé technique du type, ex. `SHORT_TEXT`
 * @param {Object} [typesLookup] métadonnées des types renvoyées par l'API
 * @returns {string}
 */
export function questionTypeLabel(key, typesLookup = {}) {
  const normalised = String(key ?? '').toUpperCase();

  return (
    QUESTION_TYPE_LABELS[normalised] ||
    typesLookup?.[normalised]?.label ||
    normalised
  );
}

export default QUESTION_TYPE_LABELS;
